import ProfileAvatar from "app/components/ProfileAvatar";
import { IMemberList } from "app/containers/Features/components/MemberSelection/types";
import React, { FC } from "react";

interface MemberMentionItemProps {
  member: IMemberList;
  onSelect: (member: IMemberList) => void;
}

const MemberMentionItem: FC<MemberMentionItemProps> = ({
  member,
  onSelect,
}) => {
  return (
    <div
      className="flex items-center gap-2.5 px-4 py-2.5 h-[44px] outline-none cursor-pointer hover:bg-gray-100 transition-colors"
      onClick={() => onSelect(member)}
      onMouseDown={(e) => e.preventDefault()}
    >
      <div className="w-full flex flex-1 gap-2 items-center truncate">
        <ProfileAvatar
          name={member.name}
          avatar={member.avatar}
          circleClassName="!size-[25px]"
        />
        <div className="flex flex-col truncate w-full">
          <span className="text-sm font-normal text-black truncate">
            {member.name}
          </span>
          {member.role && (
            <span className="text-xs font-normal text-secondary truncate">
              {member.role}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default MemberMentionItem;
